import SectionHeader from '../SectionHeader/SectionHeader';
import { useState, useEffect } from 'react';
import {  useTranslation } from 'next-i18next';
import { BlogPostsCarousel } from './BlogPostsCarousel';
import styled from 'styled-components';

const BlogWrapper = styled.div`
  background: #000104;
  padding-bottom: 40px;
`;

const Blog = ({ posts }) => {
  const { t } = useTranslation();

  const [windowWidth, setWindowWidth] = useState(null);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <BlogWrapper id='media'>
      <SectionHeader
        title={t('blogSection.title')}
        description={t('blogSection.description')}
        lineColor={'#CBFA05'}
        paddingBotton={windowWidth <= 992 ? '24px' : '40px'}
      />
      <div>
        {posts && <BlogPostsCarousel posts={posts} />}
      </div>
    </BlogWrapper>
  );
};

export default Blog;
